// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__aN-PF","Main":"Page_Main__ZhNUS","VerticalCenter":"Page_VerticalCenter__PDtIP","Inverse":"Page_Inverse__qVW7D"};